// extracted by mini-css-extract-plugin
export default {"title":"Card_title__NHTkm","sectionCard":"Card_sectionCard__96BOZ"};